import { FaLinkedin, FaInstagram, FaEnvelope } from "react-icons/fa";

function ContactPage() {
    return (
        <div id="background" className="bg-stone-300 min-h-screen w-full p-2 lg:p-6">
            <div
                id="full"
                className="bg-stone-50 p-8 lg:p-12 rounded-lg w-full shadow-md max-w-4xl mx-auto text-center space-y-12"
            >
                {/* Hero */}
                <section>
                    <h1 className="text-4xl font-extrabold text-stone-800">Get in Touch</h1>
                    <div className="w-20 h-1 bg-blue-600 mx-auto my-4 rounded-full" />
                    <p className="text-gray-700 max-w-2xl mx-auto text-lg">
                        I’d love to hear from you! Whether you want to collaborate, have questions,
                        or just want to say hi, drop me a message.
                    </p>
                </section>

                {/* Contact Options */}
                <section className="grid gap-6 sm:grid-cols-3">
                    {/* Email */}
                    <a
                        href="mailto:vanhovelander@outlook.com"
                        className="flex flex-col items-center gap-3 bg-gray-100 rounded-xl p-6 hover:bg-gray-200 hover:-translate-y-1 transition shadow-sm hover:shadow-md"
                    >
                        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-200">
                            <FaEnvelope className="text-2xl text-stone-700" />
                        </div>
                        <span className="text-sm font-medium text-stone-800 break-all">
                            vanhovelander@outlook.com
                        </span>
                    </a>

                    {/* LinkedIn */}
                    <a
                        href="https://www.linkedin.com/in/lander-v-00ab09295/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex flex-col items-center gap-3 bg-[#0077b5] text-white rounded-xl p-6 hover:bg-[#006097] hover:-translate-y-1 transition shadow-sm hover:shadow-md"
                    >
                        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20">
                            <FaLinkedin className="text-2xl" />
                        </div>
                        <span className="text-sm font-medium">LinkedIn</span>
                    </a>

                    {/* Instagram */}
                    <a
                        href="https://www.instagram.com/vanhovelander/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex flex-col items-center gap-3 bg-[#e1306c] text-white rounded-xl p-6 hover:-translate-y-1 transition shadow-sm hover:shadow-md"
                    >
                        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20">
                            <FaInstagram className="text-2xl" />
                        </div>
                        <span className="text-sm font-medium">Instagram</span>
                    </a>
                </section>

                <section>
                    <p className="text-gray-600 text-lg">
                        Let’s <span className="font-semibold text-blue-600">connect</span>!
                    </p>
                </section>
            </div>
        </div>
    );
}

export default ContactPage;
